var map = {
	"./administration/administration.module": [
		"./src/app/administration/administration.module.ts",
		"administration-administration-module~sworkplace-sworkplace-module~workplace-workplace-module",
		"administration-administration-module~workplace-workplace-module",
		"administration-administration-module"
	],
	"./students/students.module": [
		"./src/app/students/students.module.ts",
		"students-students-module"
	],
	"./sworkplace/authentication/authentication.module": [
		"./src/app/sworkplace/authentication/authentication.module.ts",
		"sworkplace-authentication-authentication-module"
	],
	"./sworkplace/sworkplace.module": [
		"./src/app/sworkplace/sworkplace.module.ts",
		"administration-administration-module~sworkplace-sworkplace-module~workplace-workplace-module",
		"sworkplace-sworkplace-module~workplace-workplace-module",
		"sworkplace-sworkplace-module"
	],
	"./workplace/workplace.module": [
		"./src/app/workplace/workplace.module.ts",
		"administration-administration-module~sworkplace-sworkplace-module~workplace-workplace-module",
		"sworkplace-sworkplace-module~workplace-workplace-module",
		"administration-administration-module~workplace-workplace-module",
		"workplace-workplace-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;